<style>
	.line-box {
		display: flex; flex-direction: row; height: 60px; align-items: center;
		
	}
	.line-name {
		width: 90px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
	}
	.line-tag {
		width: 600px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 10px;
		margin-top: 10px;
	}
	
	
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 120px;
	    height: 120px;
	    line-height: 120px;
	    text-align: center;
	  }
	  .avatar {
	    width: 120px;
	    height: 120px;
	    display: block;
	  }
</style>

<template>
	<div>
		<div class="upload-box">
			<div class="line-name">主图：</div>
			<div style="display: block;">
				<el-upload class="avatar-uploader" :action="this.$http_url + '/Upload/UploadImage'" :headers="headers" :show-file-list="false" 
					:on-success="UploadSuccess1"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="form.banner_fullurl" :src="form.banner_fullurl" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 建议长方形尺寸300x300，非长方形会遮挡显示</div>
		</div>
		<div class="line-box">
			<div class="line-name">平台名称：</div>
			<el-input style="width: 620px;" placeholder="请填写平台名称" v-model="form.app_name"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">平台描述：</div>
			<el-input style="width: 620px;" placeholder="请填写平台描述" v-model="form.app_desc"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">H5链接：</div>
			<el-input type="text" style="width: 620px;" placeholder="请填写H5链接" v-model="form.h5_url"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">API地址：</div>
			<el-input type="text" style="width: 620px;" placeholder="请填写API地址" v-model="form.api_url"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">Mqtt地址：</div>
			<el-input type="text" style="width: 620px;" placeholder="请填写Mqtt地址" v-model="form.mqtt_url"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">平台编码：</div>
			<el-input type="text" style="width: 620px;" placeholder="请填写平台编码" v-model="form.run_code"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 开发使用，请勿随意修改。</div>
		</div>
		<div class="line-box">
			<div class="line-name">联系客服：</div>
			<el-switch
				v-model="form.is_service"
				:active-value="1"
				:inactive-value="0" >
			</el-switch>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 开启后，面板按钮显示"联系客服"。</div>
		</div>
		<div class="line-box">
			<div class="line-name">免费使用：</div>
			<el-switch
				v-model="form.is_free"
				:active-value="1"
				:inactive-value="0" >
			</el-switch>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 开启后，所有用户无需额外开通，即可使用。</div>
		</div>
		<div class="line-box">
			<div class="line-name">排序值：</div>
			<el-input type="number" style="width: 620px;" placeholder="从小到大排序" v-model="form.sorts"></el-input>
		</div>
		<div style="width: 100%; margin-top: 20px;">
			<el-button style="width: 100%;" type="danger" @click="addProduct">确认修改</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:['form'],
		data(){
			return {
				headers:{
					Authorization:''
				}
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
		methods: {
			addProduct() {
				// 验证格式
				if(this.form.banner_url == ""){
					return this.$message({ message: '请上传平台主图', type: 'warning' });
				}
				if(this.form.app_name == ""){
					return this.$message({ message: '请填写平台名称', type: 'warning' });
				}
				if(this.form.app_desc == ""){
					return this.$message({ message: '请填写平台描述', type: 'warning' });
				}
				if(this.form.h5_url == ""){
					return this.$message({ message: '请填写平台H5地址', type: 'warning' });
				}
				if(this.form.run_code == ""){
					return this.$message({ message: '请填写平台编码', type: 'warning' });
				}
				// 提交上传
				this.submit();
			},
			submit(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/System/editPlat", this.form).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			beforeUpload(file){
			},
			UploadSuccess1(res, file, fileList){
				if(res.code == 200)
				{
					this.form.banner_url = res.file_path;
					this.form.banner_fullurl = this.$http_host + res.file_path;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			}
		},
	}
</script>
